// extracted by mini-css-extract-plugin
export const background = "one-module--background--3Kv5U";
export const wrapper = "one-module--wrapper--tgITp";
export const layout = "one-module--layout--3-wY4";
export const left = "one-module--left--3xBCI";
export const title = "one-module--title--3kIaN";
export const content = "one-module--content--1hFyE";
export const table = "one-module--table--1F_ct";
export const tableCellLabel = "one-module--tableCellLabel--3UgSI";
export const featuredImage = "one-module--featuredImage--1ygf2";